/**
 * AddCountryListCtrl controller
 */

/**
 * AddCountryListCtrl controller
 *
 * @class AddReminderCtrl
 * @memberof mwApp/packages
 * @see mwApp/settings
 *
 * @ngdoc controller
 * @name mwApp/settings.controller:AddCountryListCtrl
 */
/* @ngInject */
export default function AddCountryListCtrl ($uibModalInstance, $timeout, cl, countries) {
  var vm = this

  /**
   * Configuration country list
   *
   * @memberof mwApp/packages.controller:AddCountryListCtrl
   * @type {Object}
   */
  vm.cl = cl

  /**
   * Configuration country list
   *
   * @memberof mwApp/packages.controller:AddCountryListCtrl
   * @type {Object}
   */
  vm.countries = countries

  /**
   * Save configuration country list, and close modal window afterwards
   *
   * @memberof mwApp/packages.controller:AddCountryListCtrl
   */
  vm.submit = function () {
    vm.setDisable()

    $timeout(() => {
      $uibModalInstance.close(cl)
      vm.unsetDisable()
    }, 700)
  }

  /**
   * Cancel editing, close modal window
   *
   * @memberof mwApp/packages.controller:AddCountryListCtrl
   */
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }
}
